export default {
  HOST: 'http://localhost/', // ドメイン名
  PROD_HOST: '/public/index.php/',
  advanceTime: 600 // 新しいtokenを繰り上げて入手する時間提前获取新token的时间(s)
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js